import React from 'react';
import { Box, Stack } from '@mui/material';
import { CssTextField } from 'components/select';
import { useRecoilState } from 'recoil';
import ProvisioningStyles from 'pages/provisioning/day2-operation-paas/style';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation-paas';
import HelpImg from 'pages/provisioning/_components/helpImg';

const QueueName = () => {
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [showHelperText, setHelperText] = React.useState(false);
    const [showHelperMsg, setHelperMsg] = React.useState('');
    const handleValueChange = (value) => {
        if (value !== order?.queueName) {
            setOrder({
                ...order,
                queueName: value,
            });
        }
    };
    React.useEffect(() => {
        if (order?.queueName && !/^[a-zA-Z0-9-_ ]{3,255}$/.test(order?.queueName)) {
            setHelperText(true);
            setHelperMsg('Queue Name should be min. 3 to max. 255 chars only.');
        } else {
            setHelperText(false);
            setHelperMsg('');
        }
    }, [order?.queueName]);

    return (
        <Stack direction="row" sx={ProvisioningStyles.stack}>
            <CssTextField
                autoComplete="off"
                size="small"
                sx={{
                    width: (theme) => theme.spacing('100%'),
                    '& .MuiFormHelperText-root': {
                        marginTop: (theme) => theme.spacing('-2'),
                    },
                }}
                label="Queue Name"
                error={showHelperText}
                helperText={showHelperText && <span style={ProvisioningStyles.disposal.helpText}>{showHelperMsg}</span>}
                value={order?.queueName || ''}
                onChange={(e) => handleValueChange(e?.target?.value)}
            />
            <Box sx={ProvisioningStyles?.helpImg}>
                <HelpImg title="Please provide your queue name" />
            </Box>
        </Stack>
    );
};

export default QueueName;
